
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 2.594l.719.688 13 13-1.438 1.438L27 16.439v11.563h-9v-10h-4v10H5V16.439L3.719 17.72l-1.438-1.438 13-13zm0 2.844l-9 9v11.563h5v-10h8v10h5V14.438z"}})])
          )
        }
      }
    